import React from "react";
import InitialScheduleTermTable from "./InitialScheduleTermTable";
import { usePermission } from "features/../../../shared/components/auth";
import {
  Actions,
  Targets,
} from "features/../../../shared/constants/permissions";
import {
  listSettlementConsiderationTerms,
  getSettlementConsiderationTerms,
  createSettlementConsiderationTerms,
  updateSettlementConsiderationTerms,
  deleteSettlementConsiderationTerms,
  downloadSettlementConsiderationTerms,
  approveSettlementConsiderationTerms,
  makeSettlementConsiderationTermsLive,
} from "./actions";

const SettlementConsiderationTermsTable = ({ dealerId }) => {
  const canApprove = usePermission(
    Targets.SettlementConsideration,
    Actions.Approve,
  );
  const canDownload = usePermission(
    Targets.SettlementConsideration,
    Actions.Download,
  );

  return (
    <InitialScheduleTermTable
      dealerId={dealerId}
      title="Settlement Consideration Terms"
      triggerText="Upload Settlement Consideration Terms"
      listAction={listSettlementConsiderationTerms}
      getAction={getSettlementConsiderationTerms}
      createAction={createSettlementConsiderationTerms}
      updateAction={updateSettlementConsiderationTerms}
      deleteAction={deleteSettlementConsiderationTerms}
      downloadAction={downloadSettlementConsiderationTerms}
      approveAction={approveSettlementConsiderationTerms}
      makeLiveAction={makeSettlementConsiderationTermsLive}
      canApprove={canApprove}
      canDownload={canDownload}
    />
  );
};

export default SettlementConsiderationTermsTable;
